export default [
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("./views/ResetPasswordView.vue"),
    props: (route) => {
      const props = {
        targetUrl: route.query["targetUrl"],
        activationKey: route.query["activation-key"],
        newUser: "false"
      };

      return props;
    }
   },
  {
    path: "/set-password",
    name: "SetPassword",
    component: () => import("./views/ResetPasswordView.vue"),
    props: (route) => {
      const props = {
        targetUrl: route.query["targetUrl"],
        activationKey: route.query["activation-key"],
          newUser: "true"
      };

      return props;
    }
   },
];
